const text = (value, fallback = '', limit = 3000) => typeof value === 'string' ? value.trim().slice(0, limit) : fallback
const color = (value, fallback) => /^#[\da-f]{6}$/i.test(String(value || '')) ? value : fallback
const followUpSent = 'We have sent you a follow-up email.'
// Upgrade only exact historical defaults on read. Preserve independently edited
// content and avoid rewriting website settings or historical registration rows.
const legacyDefaultCopy = {
  activationDescription: [
    'Secure your 1-year extended warranty in just one click.',
    'Request your 2-year extended warranty and confirm your choice by replying to our email.',
  ],
  successTitle: ['Your Warranty Is Activated!'],
  successMessage: [
    'Your warranty has been successfully activated. Thank you for choosing us!\n\nIf you have any questions or need assistance, please feel free to contact us at {{contactEmail}}. We’re here to help.',
    `Thank you for choosing {{brandName}}. We value your experience.\n\n${followUpSent} Please reply YES if you would like a 2-year extended warranty, or NO if you prefer not to. Our team will confirm your warranty status after reviewing your reply.\n\nIf you have any questions, please contact us at {{contactEmail}}.`,
  ],
}
export const safeNoOrderUrl = (value) => {
  try {
    const url = new URL(String(value || ''))
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : ''
  } catch { return '' }
}

export const defaultNoOrderPage = () => ({
  title: 'Welcome to effortless\nvoice.',
  subtitle: 'Your voice, amplified—not your effort.',
  introduction: 'Thank you for choosing {{brandName}}!\nMake every word effortless. Make every moment heard.',
  heartEnabled: true,
  heartImageUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/2764.png',
  activationLabel: 'Activate Your Warranty',
  activationDescription: 'Request your 1-year extended warranty and confirm your choice by replying to our email.',
  activationColor: '#4b95f7',
  videoEnabled: false,
  videoLabel: 'Watch Operation Video',
  videoDescription: 'Watch our operation video for product setup and troubleshooting instructions.',
  videoUrl: '', videoColor: '#9d63fa',
  helpEnabled: false,
  helpLabel: 'Got questions?',
  helpDescription: 'From choosing to using — everything you need to know, all in one place.',
  helpUrl: '', helpColor: '#69d45b',
  tip: 'Tip: Activating your warranty also gives you lifetime technical support.',
  tipImageUrl: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f4a1.png',
  backgroundTop: '#ffffff', backgroundMiddle: '#c5e9f6', backgroundBottom: '#79acf1',
  titleColor: '#080808', textColor: '#52666e',
  formTitle: 'Activate Your Warranty',
  formDescription: 'Enter your email address to register your extended warranty. No order number or name is needed.',
  emailLabel: 'Email address', emailPlaceholder: 'you@example.com', submitLabel: 'Register Warranty',
  successTitle: 'Thank You for Your Support!',
  successMessage: `Thank you for choosing {{brandName}}. We value your experience.\n\n${followUpSent} Please reply YES if you would like a 1-year extended warranty, or NO if you prefer not to. Our team will confirm your warranty status after reviewing your reply.\n\nIf you have any questions, please contact us at {{contactEmail}}.`,
  successContactEmail: '',
})

export const normalizeNoOrderPage = (value = {}) => {
  const source = value && typeof value === 'object' && !Array.isArray(value) ? value : {}
  const defaults = defaultNoOrderPage()
  const normalized = Object.fromEntries(Object.entries(defaults).map(([key, fallback]) => [key,
    typeof fallback === 'boolean' ? (key === 'heartEnabled' ? source[key] !== false : source[key] === true)
      : key.endsWith('Color') || key.startsWith('background') ? color(source[key], fallback)
        : key.endsWith('Url') ? safeNoOrderUrl(source[key] ?? fallback) : text(source[key], fallback),
  ]))
  for (const [key, legacyValues] of Object.entries(legacyDefaultCopy)) {
    if (typeof normalized[key] === 'string' && legacyValues.includes(normalized[key].replace(/\r\n?/g, '\n'))) normalized[key] = defaults[key]
  }
  return normalized
}

export const noOrderBrandCopy = (value, brandName) => String(value || '').replaceAll('{{brandName}}', String(brandName || 'our brand'))

export const noOrderSuccessCopy = (value, brandName, emailSent) => {
  const message = String(value || '')
  const statusCopy = !emailSent && message === defaultNoOrderPage().successMessage
    ? message.replace(followUpSent, 'Please look out for our follow-up email.') : message
  return noOrderBrandCopy(statusCopy, brandName)
}
